export default "__VITE_ASSET__BZ2lcX2q__"